<div class="container-fluid top-nav">
        <div class="row">
            <div class="col">
                <div class="card border-0 rounded content">
                 <app-orgmemberlist [acceptedJoiner]="acceptedJoiner"></app-orgmemberlist>
                </div>
            </div>
        </div>
        <div class="spacer"></div>
</div>


